import {
  DefinitionLevels,
  FEATURE_FLAGS_NAMES,
  SettingValues
} from '@linearb/linjs-common';
import { SETTING_NAMES } from 'common/constants/constants';
import useSettingsService from 'components/hooks/useSettingsService';

export function useSettings(teamId: number) {
  const { getSettingOrDefinitionValue } = useSettingsService();

  return {
    fetchBranchesActivityFiltersCountEnabled: getSettingOrDefinitionValue({
      name: FEATURE_FLAGS_NAMES.fetchBranchesActivityFiltersCountEnabled
    }),
    branchMetricsPerPrIssuerEnabled: getSettingOrDefinitionValue({
      name: FEATURE_FLAGS_NAMES.branchMetricsPerPrIssuerEnabled
    }),

    releaseStages: getSettingOrDefinitionValue({
      name: SETTING_NAMES.RELEASE_STAGES
    }),
    isShowPRLabelsFilterEnabled: getSettingOrDefinitionValue({
      name: FEATURE_FLAGS_NAMES.showPRLabelsFilter
    }),

    isCycleTimeInspectionEnabled: getSettingOrDefinitionValue({
      name: FEATURE_FLAGS_NAMES.isCycleTimeInspectionEnabled
    }),
    servicesTabEnabledFF: getSettingOrDefinitionValue({
      name: FEATURE_FLAGS_NAMES.servicesTabEnabled
    }),
    excludeBranchFromCycleTimeFF: getSettingOrDefinitionValue({
      name: FEATURE_FLAGS_NAMES.excludeBranchFromCycleTime
    }),
    codeChangesSmallTopRange: getSettingOrDefinitionValue(
      { name: SettingValues.CODE_CHANGES_SMALL_TOP_RANGE },
      0
    ),
    codeChangesMediumTopRange: getSettingOrDefinitionValue(
      { name: SettingValues.CODE_CHANGES_MEDIUM_TOP_RANGE },
      0
    ),
    newWorkSmallTopRange: getSettingOrDefinitionValue(
      { name: SettingValues.NEW_WORK_SMALL_TOP_RANGE },
      0
    ),
    newWorkMediumTopRange: getSettingOrDefinitionValue(
      { name: SettingValues.NEW_WORK_MEDIUM_TOP_RANGE },
      0
    ),

    highRiskPrSize: getSettingOrDefinitionValue(
      {
        name: SettingValues.HIGH_RISK_THRESHOLDS,
        key: 'pr_size',
        definitionLevel: DefinitionLevels.TEAM,
        teamId
      },
      100
    ),
    highRiskNewWork:
      100 -
      getSettingOrDefinitionValue(
        {
          name: SettingValues.HIGH_RISK_THRESHOLDS,
          key: 'rework_refactor',
          definitionLevel: DefinitionLevels.TEAM,
          teamId
        },
        50
      ),

    isHideNonWorkingDaysEnabled: getSettingOrDefinitionValue(
      { name: SettingValues.HIDE_NON_WORKING_DAYS },
      false
    ),
    showPersonalInformation: getSettingOrDefinitionValue(
      { name: SETTING_NAMES.SHOW_PERSONAL_INFORMATION },
      false
    )
  };
}
